import SmsTemplates from "./components/SmsTemplates";

export default SmsTemplates;
